module.exports = __webpack_public_path__ + "img/haft-poznan-08.2e6cca5b.jpg";